import {FrontDate} from "../../../domain/model/frontDate";
import {entity} from "../rpc/api";
import CompanyList = entity.CompanyList;

class CompanyConvertResponse {
    public static from(from: entity.Company): CompanyConvertResponse {
        // Backend => FrontEnd における型変換
        const establishedAtDate: FrontDate = FrontDate.from(from.establishedDate);
        const createdAtDate: FrontDate = FrontDate.from(from.createdAt);

        return new CompanyConvertResponse(
            from.id,
            from.name,
            from.gsLogoURL,
            from.signedLogoURL,
            from.webURL,
            establishedAtDate,
            from.postalCode,
            from.place,
            from.business,
            from.representativeName,
            from.capitalStock,
            from.employeeScale,
            from.introduction,
            from.accordingCompanyName,
            from.accordingCompanyPostalCode,
            from.accordingCompanyAddress,
            from.invoiceDepartmentName,
            from.status,
            from.isAgreeTerms,
            createdAtDate,
            from.isAdmin
        );
    }

    constructor(
        // 企業ID
        public readonly id: string,
        // 企業名
        public readonly name: string,
        // 企業ロゴ画像
        public readonly gsLogoURL: string,
        public readonly signedLogoURL: string,
        // 企業WEB　URL
        public readonly webURL: string,
        // 設立年月
        public readonly establishedAt: FrontDate,
        // 郵便番号
        public readonly postalCode: string,
        // 所在地
        public readonly place: string,
        // 業種
        public readonly business: entity.Company.Business[],
        // CEO名前
        public readonly representativeName: string,
        // 資本金
        public readonly capitalStock: string,
        // 従業員規模
        public readonly employeeScale: entity.Company.EmployeeScale,
        // 会社紹介メッセージ
        public readonly introduction: string,
        // 請求企業名
        public readonly accordingCompanyName: string,
        // 請求先郵便番号
        public readonly accordingCompanyPostalCode: string,
        // 請求先住所
        public readonly accordingCompanyAddress: string,
        // 請求部署名
        public readonly invoiceDepartmentName: string,
        // (ステータス)
        public readonly status: entity.Company.Status,
        public readonly isAgreeTerms: boolean,
        // public readonly card: CreditCard | null,
        // (タイムスタンプ)
        public readonly createdAt: FrontDate,
        public readonly isAdmin: boolean
    ) {
    }
}

class CompanyConvertResponseList {
    public static from(from: CompanyList): CompanyConvertResponseList {
        const items: CompanyConvertResponse[] = [];

        from.items.map((item, index) => {
            return items.push(CompanyConvertResponse.from(item as entity.Company));
        });

        return new CompanyConvertResponseList(items);
    }

    constructor(public readonly items: CompanyConvertResponse[]) {
    }
}

export {CompanyConvertResponse, CompanyConvertResponseList};



// WEBPACK FOOTER //
// ./src/infra/api/service/company_api_convert.ts